import axios from "@/utils/request.js";
import qs from "qs"
// 获取活动详情
export const getDetail = (params) => axios({
    url: "/api/web-operate/lottery2/manager/lot/detail",
    method: 'get',
    params
})
// 获取剩余抽奖次数
export const getResidueDegree = (params) => axios({
  url: "/api/web-operate/lottery2/manager/lot/user/count",
  method: 'get',
  params
})
// 抽奖 -1未中奖；0奖品已派完；1中奖不显示奖品；大于1为中奖并显示奖品id
export const lot = (params) => axios({
  url: "/api/web-operate/lottery2/manager/lot",
  method: 'post',
  params
})

// 获取奖品详情
export const prizeDetail = (params) => axios({
  url: "/api/web-operate/lottery2/manager/prize/detail",
  method: 'get',
  params
})


// 获取我的奖品  --新
export const myWinner = (params) => axios({
  url: "/api/web-operate/lottery2/manager/winner/my",
  method: 'get',
  params
})




//获取闯关详情有token
export const getBreakthroughQuestion = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/questions",
    method: 'get',
    params
})
//答案检验
export const getBreakthroughAnswer = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/checkAnswer",
    method: 'get',
    params
})
//排行榜
export const getBreakthroughRank = (params) => axios({
    url: "/api/web-operate/platform/breakthrough/rank/page",
    method: 'get',
    params
})

//排行榜-ay
export const getBreakthroughRankCustom = (params) => axios({
  url: "/api/web-operate/platform/breakthrough/custom/rank/page",
  method: 'get',
  params
})

//报名 
export const register = (params) => axios({
  url: "/api/web-operate/platform/breakthrough/register",
  method: 'post',
   data: params
})